import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import { RESET_STATE_ACTION_TYPE } from "./actions/reset"
import { posCommonReducer, posCommonSlice } from "./slices/pos-common"
import { authReducer, authSlice } from "./slices/auth/auth"
import { breadcrumbReducer, breadcrumbSlice } from "./slices/breadcrumbs-slice"
// import { alertReducer, alertSlice } from "./slices/alert"

const reducers = {
  [posCommonSlice.name]: posCommonReducer,
  [authSlice.name]: authReducer,
  [breadcrumbSlice.name]: breadcrumbReducer
}

const combinedReducer = combineReducers<typeof reducers>(reducers)

export const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_STATE_ACTION_TYPE) {
    state = {} as RootState
  }

  return combinedReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof combinedReducer>
export const useTypedDispatch = (): any => useDispatch<AppDispatch>()
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
